import styled from 'styled-components';
import { IconButton, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { BADGE_VARIANTS, Badge } from 'ui/badge';
import { Body2, colors } from 'ui/theme';
import { ActionMenu } from 'ui/actionMenu';
import { AllowedActionMenuElements, MENU_ALIGNMENTS } from 'ui/actionMenu/types';
import { Overflow, Checkmark, World, Delete } from 'ui/icons';
import { MODAL_NAMES, ModalState, ModalStatePayload } from '../../contexts';

const Wrapper = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 1fr auto;
  padding: 2.5px 15px;
  &:first-child {
    padding-top: 5px;
  }
  &:last-child {
    padding-bottom: 5px;
  }
`;

const CheckmarkWithoutStroke = styled(Checkmark)`
  path {
    stroke-width: 0;
  }
`;

const Left = styled.div`
  align-items: center;
  display: inline-flex;
  gap: 12px;
`;

const Name = styled(Body2)`
  margin: 0;
`;

type Props = {
  locale: string;
  isDefault: boolean;
  showModal: (modalState: ModalState<ModalStatePayload>) => void;
};

export const LocaleListRow = ({ locale, isDefault, showModal }: Props) => {
  const onClickSetDefault = () => {
    showModal({
      name: MODAL_NAMES.SET_DEFAULT_LOCALE,
      payload: locale,
    });
  };

  const onClickDelete = () => {
    showModal({
      name: MODAL_NAMES.DELETE_LOCALE,
      payload: locale,
    });
  };

  const options = [
    ...(!isDefault
      ? [
          {
            id: 'set-default-locale',
            content: (
              <>
                <CheckmarkWithoutStroke color={colors.grey60} />
                <span>Set default</span>
              </>
            ),
            as: AllowedActionMenuElements.Button,
            onClick: onClickSetDefault,
          },
        ]
      : []),
    {
      id: 'delete-locale',
      isDestructive: true,
      content: (
        <>
          <Delete />
          <span>Delete</span>
        </>
      ),
      as: AllowedActionMenuElements.Button,
      onClick: onClickDelete,
    },
  ];

  return (
    <Wrapper role="listitem" aria-labelledby={locale}>
      <Left>
        <World />
        <Name id={locale}>{locale || ''}</Name>
        {isDefault && (
          <Badge variant={BADGE_VARIANTS.POSITIVE} icon={<></>}>
            default
          </Badge>
        )}
      </Left>
      <ActionMenu id="overflow-menu" align={MENU_ALIGNMENTS.RIGHT} options={options}>
        <IconButton size={BUTTON_SIZES.SMALL} type="button" variant={BUTTON_VARIANTS.GHOST}>
          <Overflow />
        </IconButton>
      </ActionMenu>
    </Wrapper>
  );
};
